export default __webpack_public_path__ + "static/media/img-equip-status.ebd798f9.png";